<div class="form-view-container">
    <h2 class="fw-bold mb-4 text-center text-light">Sign In</h2>
    <form (ngSubmit)="login()">
        <div class="form-floating mb-3 position-relative">
            <input type="text" class="form-control" id="username" name="username" placeholder="USERNAME"
                autocomplete="username" [ngModel]="username()" (ngModelChange)="onUsernameChange($event)"
                (focus)="isElectron() && showAccountList.set(rememberedAccounts().length > 0)"
                (click)="isElectron() && showAccountList.set(rememberedAccounts().length > 0)" (blur)="onBlur()"
                required>
            <label for="username">USERNAME</label>

            @if(isElectron() && showAccountList() && rememberedAccounts().length > 0) {
            <ul class="remembered-accounts-list" role="listbox" aria-label="Saved accounts">
                @for(account of rememberedAccounts(); track account.username) {
                <li (mousedown)="selectAccount(account)" (keydown.enter)="selectAccount(account)"
                    (keydown.space)="selectAccount(account); $event.preventDefault()" tabindex="0" role="option">
                    <i class="bi bi-person-fill me-2" aria-hidden="true"></i>{{ account.username }}
                </li>
                }
            </ul>
            }
        </div>

        <div class="input-group mb-2">
            <div class="form-floating">
                <input [type]="showPassword() ? 'text' : 'password'" class="form-control" id="password" name="password"
                    placeholder="PASSWORD" [ngModel]="password()" (ngModelChange)="password.set($event)"
                    autocomplete="current-password" required>
                <label for="password">PASSWORD</label>
            </div>
            <button class="btn btn-outline-password-toggle d-flex align-items-center justify-content-center"
                type="button" (click)="showPassword.set(!showPassword())"
                [attr.aria-label]="showPassword() ? 'Hide password' : 'Show password'"
                [attr.aria-pressed]="showPassword()"
                [title]="showPassword() ? 'Hide Password' : 'Show Password'">
                @if (showPassword()) {
                <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor"
                    class="bi bi-eye-slash-fill" viewBox="0 0 16 16" aria-hidden="true">
                    <path
                        d="m10.79 12.912-1.614-1.615a3.5 3.5 0 0 1-4.474-4.474l-2.06-2.06C.938 6.278 0 8 0 8s3 5.5 8 5.5a7 7 0 0 0 2.79-.588M5.21 3.089A7 7 0 0 1 8 2.5c5 0 8 5.5 8 5.5s-.939 1.721-2.64 3.29l-2.134-2.134a3.5 3.5 0 0 0-4.474-4.474z" />
                    <path
                        d="M5.525 7.646a2.5 2.5 0 0 0 2.829 2.829zm4.907 3.562-1.15-1.15a3.5 3.5 0 0 0-3.473-3.472l-1.15-1.15a4.5 4.5 0 0 1 5.773 5.773z" />
                </svg>
                } @else {
                <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor"
                    class="bi bi-eye-fill" viewBox="0 0 16 16" aria-hidden="true">
                    <path d="M10.5 8a2.5 2.5 0 1 1-5 0 2.5 2.5 0 0 1 5 0" />
                    <path
                        d="M0 8s3-5.5 8-5.5 8 5.5 8 5.5-3 5.5-8 5.5S0 8 0 8m8 3.5a3.5 3.5 0 1 0 0-7 3.5 3.5 0 0 0 0 7" />
                </svg>
                }
            </button>
        </div>

        @if (errorMessage()) {
        <div class="text-danger small mt-2 ps-2" role="alert" aria-live="assertive">{{ errorMessage() }}</div>
        }

        <div class="d-flex gap-4 mt-3">
            @if(isElectron()) {
            <div class="form-check">
                <input type="checkbox" class="form-check-input" id="rememberMeCheck" name="rememberMe"
                    [ngModel]="rememberMe()" (ngModelChange)="rememberMe.set($event)">
                <label class="form-check-label fw-bold" for="rememberMeCheck">
                    Remember me
                </label>
            </div>
            }
        </div>

        <div class="mt-3">
            <button type="submit"
                class="btn btn-danger w-100 d-flex align-items-center justify-content-center btn-submit"
                style="height: 4rem;" [disabled]="!username() || !password()"
                [attr.aria-label]="loggingIn() ? 'Signing in...' : 'Sign in'" title="Log In">
                @if(!loggingIn()) {
                <svg class="arrow-icon text-white" style="width: 2.5rem; height: 2.5rem;" fill="none"
                    stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M14 5l7 7m0 0l-7 7m7-7H3">
                    </path>
                </svg>
                }@else{
                <div class="spinner-border" role="status" aria-label="Loading">
                    <span class="visually-hidden">Loading...</span>
                </div>
                }
            </button>
        </div>
    </form>
    <div class="mt-3 text-center small login-links">
        <a href="#" (click)="$event.preventDefault(); changeView.emit('recover')" role="button"
            class="fw-bold text-decoration-none text-uppercase login-link">Can't sign in?</a>
        <span class="mx-2 link-divider" aria-hidden="true">|</span>
        <a href="#" role="button" class="fw-bold text-decoration-none text-uppercase login-link" data-bs-toggle="modal"
            data-bs-target="#registerModal">Create Account</a>
    </div>
</div>